import { LoadingService } from 'src/app/core/layout/services/loading.service';
import { ActivatedRoute } from '@angular/router';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { NavController } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { AccountBalanceService } from '@wlp/ui-bs-cashin';
import { ExtractService, TransferService } from '@wlp/ui-bs-cashout';
import { UserInfoService } from '@wlp/ui-bs-login';
import { UserInfoProfile } from '@wlp/ui-bs-login/lib/dto/user-info-profile';
import { UICHeaderUserInfoService } from '@wlp/ui-c-header-user-info';
import { LayoutConfigService } from 'src/app/core/layout/services/layout-config.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'ui-t-transfer-receipt',
  templateUrl: './transfer-receipt-favorites.page.html',
  styleUrls: ['./transfer-receipt-favorites.page.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TransferReceiptFavoritesPage implements OnInit, OnDestroy {
  title: string;

  public transferDataReceipt: any;
  private userProfile: UserInfoProfile;
  public scheduling: boolean;
  public brand: string;

  public voucherHtml: SafeHtml = '';
  public hasVoucherTemplate: boolean = false;

  @ViewChild('contentToPDF', {static: false}) contentToPDF: ElementRef;

  constructor(
    private accountBalanceService: AccountBalanceService,
    private transferService: TransferService,
    protected userInfoService: UserInfoService,
    protected extractService: ExtractService,
    private headerService: UICHeaderUserInfoService,
    public activatedRoute: ActivatedRoute,
    private layoutConfigService: LayoutConfigService,
    private navCtrl: NavController,
    private storage: Storage,
    public loadService: LoadingService,
    private sanitizer: DomSanitizer,
    private elementRef: ElementRef
  ) {
    this.brand = this.layoutConfigService.getConfig('wlTheme.header.billet.brand.logo');
    this.loadDataReceipt();
    this.activatedRoute.params.subscribe((params) => {

      if (params.type === 'true') {
        this.scheduling = true;
        this.title = 'CASH_OUT.TRANSFER_RECEIPT.HEADER.TITLE_SCHEDULING';
      } else {
        this.title = 'CASH_OUT.TRANSFER_RECEIPT.HEADER.SUBTITLE';
      }
    });
  }

  ngOnInit() {
    this.loadService.show();
    this.loadUser();
    let selectTransferReceipt = window.document.getElementById('container-transfer-flow');
    selectTransferReceipt.style.height = `${window.document.getElementById('container-transfer-flow').offsetHeight * 2}px`
  }

  private async loadDataReceipt() {
    this.transferService.getTransferConfirmation().subscribe((res) => {
      this.transferDataReceipt = res;
      if (this.transferDataReceipt !== undefined && this.transferDataReceipt !== null) {
        this.storage.set('transferReceipt', this.transferDataReceipt).then(() => {
          this.getVoucher([this.transferDataReceipt.transactionIdConsult]);
        });
      } else {
        this.storage.get('transferReceipt').then((res) => {
          if (res) {
            this.transferDataReceipt = res;
            this.getVoucher([this.transferDataReceipt.transactionIdConsult]);
          }
        });
      }
    });
  }

  getVoucher(transactionId: string[]) {
    this.extractService.findTemplateVoucherByTransactionsId(transactionId)
      .subscribe(
        res => {
          const htmlReturned = res[0].emittedVoucher;
          this.voucherHtml = this.sanitizer.bypassSecurityTrustHtml(htmlReturned);
          this.hasVoucherTemplate = true;
        },
        error => {
          console.error('Failed to get voucher: ', error);
        },
        () => {
          this.loadService.hide();
        }
      )
  }

  loadUser() {
    try {
      const userDetails = this.userInfoService.getInfoProfile();
      userDetails.then((user) => {
        this.userProfile = user;
        this.loadBalance(user.uuidWhiteLabel, user.uuidAccount);
      });
    } catch (e) {
      console.error('Failed to load user details', e);
    }
  }

  print() {
    // let printContents: string;
    // let css: string;
    // printContents = document.getElementById('print-section').innerHTML;
    // css = '<style> font-family: sans-serif; </style>';
    // window.print();
    // /* this.transferService.print(printContents, css); */
  }

  private loadBalance(uuidWL: string, uuidAccount: string): void {
    this.accountBalanceService
      .getBalance(uuidWL, uuidAccount)
      .then((res) => {
        this.accountBalanceService.setBalanceSubject(res.balance);
        this.headerService.updateValue(true); // atualiza os valores
      })
      .catch((err) => this.accountBalanceService.getErroMessage(err));
  }

  ngOnDestroy() {

  }
  ionViewDidLeave() {
    this.transferService.unsubscribe();
    this.transferDataReceipt = undefined;
    this.storage.remove('transferReceipt');
    this.storage.remove('typeTransfer');
  }
  download() {
    const elementHtml = this.contentToPDF.nativeElement.innerHTML;
    this.extractService.downloadStatementPdf(elementHtml).subscribe((res) => {
      FileSaver.saveAs(
        new Blob([res]),
        `Comprovante-${new Date().getDate()}/${new Date().getMonth() + 1}/${new Date().getUTCFullYear()}-${this.transferDataReceipt.transactionIdConsult}.pdf`
      );
    });
  }
}
